export enum LocalStorageStore {
  Expiration = 'golfshop.expiration',
  Cart = 'golfshop.cart',
  RadarLicenses = 'golfshop.radarLicenses',
  Currency = 'golfshop.currency',
}
